import {request} from '../../../services/HttpRequestService';
import {storageService} from '../../../services/storageService';
import {reducer, useSetStateReducer} from '../../../Custom Hooks/useMemorizedReducer/useMemorized.reducer';
import {initializeState} from '../Config/CreateAutoProject.state';
import {useHistory, useLocation} from 'react-router-dom';
import {useEffect, useState} from 'react';
import useUploadProcess from '../../../Custom Hooks/useUploadProcess/useUploadProcess';
import {BACKEND_ERRORS} from '../../../configuration/backendErrors/BackendErrors.config';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import {projectStatus, projectTypes} from '../../DataProjects/Config/DataProjects.constants';
import loadService from '../../../services/loadService';
import {_INPUT_RULES} from '../../../configuration/index.config';
import {BackendTagField} from '../../../configuration/backendFileds/backendFileld.config';
import {IClass} from '../../RandomSampler/Config/RandomSampler.types';


const useCreateAutoClassificationProject = (sharedProjectId = -1) => {
    const [getState, setState] = useSetStateReducer(reducer, initializeState);
    const history = useHistory();
    const [openExitModal, setOpenExitModal] = useState(false);
    const autoProjectState = getState();
    const params = new URLSearchParams(history.location.search);
    const popup = params.get('popup');

    autoProjectState.projectId = sharedProjectId;

    const {
        setFiles,
        onDoneProcess,
        uiFileList,
        numberOfFiles,
        uploadCounter,
        onDeleteFile,
        uiFiledFileList,
        retryAllFiledFiles,
        fileBoilerPlate,
        setUiFileListFromOutSide,
        closeModal,
        projectIdUploadProcess,
        setUiFileList
    } = useUploadProcess(-1, sharedProjectId, true);
    const location = useLocation();
    const { state } = location;
    const { projectCopy } = state || {};

    /**
     * getProjectData - get project data if draft
     * @param projectId - project id
     */
    const getProjectData = async (projectId) => {
        try {
            const res = await request.get(storageService.loadFromStorage('token'), 'GET_PROJECT_DETAILS', false, projectId);
            const {classes, tags, id, name, description} = res.data;
            const newState = {
                projectName: name,
                projectNameInit: name,
                isProjectInitialized: true,
                tags: tags,
                classes: tags.map((t) => ({...t, imageList: classes && classes[t.tag_id] ? classes[t.tag_id].map((file, index) => file = {...fileBoilerPlate(file, index), status: 'done'}) : []})),
                projectId: id,
                minReference: _INPUT_RULES.MIN_REFERENCE_IMAGES,
                projectDescription: description,
                projectDescriptionInit: description};

            setState(newState);
        } catch (e) {
            console.log(e);
        }
    };

    /**
     * initialNewAutoProject - initiate a new auto classifier project
     * @param name - the name of the project
     * @param newState - is need new state
     **/
    const initialNewAutoProject = async (name, newState = {}, chosenTags) => {
        try {
            setState({nameExistError: ''});
            const filteredTags = autoProjectState.tags.filter((tag) => chosenTags.includes(tag.tag_id));
            const res = await request.post(storageService.loadFromStorage('token'), 'CREATE_NEW_PROJECT', {
                name: name,
                description: autoProjectState.projectDescription,
                tags: filteredTags,
                labels: autoProjectState.labels,
                attributes: autoProjectState.attributes,
                status: projectStatus.regular,
                type: projectTypes.automatic,
                active: true
            });
            const project_id = res.data.id;

            const stateToRender = newState ? {projectId: project_id, isProjectInitialized: true, ...newState} : {projectId: project_id, isProjectInitialized: true};

            setState(stateToRender);

            return project_id;

        } catch (e) {
            const {data} = e.response;

            handleNameExistError(data);

            return -1;
        }
    };

    const setNewFiles = (files) => {
        const filesState = JSON.parse(JSON.stringify(autoProjectState.files));
        const imageType = /image.*/;
        const allFiles = loadService.loopOnFiles(files, true, imageType);

        allFiles.forEach((file) => {
            filesState.push(file);
        });


        return filesState;
    };

    /**
     * uploadImages - upload images - if project is empty upload project + images
     * @param files - files from computer
     */
    const uploadImages = async (files) => {
        if (projectIdUploadProcess === -1) {
            await initialNewAutoProject(autoProjectState.projectName, {files: setNewFiles(files)}, []);
        } else {
            setState({files: setNewFiles(files)});
        }
    };


    /**
     * editDraftAutoProject - edit an auto classifier draft project
     * @param project_id - optional, the id of the project
     * @param project_status - optional, the status of the project
     **/
    const editDraftAutoProject = async (project_id = null, project_status = projectStatus.draft) => {
        try {
            setState({nameExistError: ''});
            const postSignedData = {
                data_project_id: project_id ? project_id : autoProjectState.projectId,
                files_dict: autoProjectState.filesDict
            };

            await request.post(storageService.loadFromStorage('token'), 'EDIT_PROJECT', {
                id: project_id ? project_id : autoProjectState.projectId,
                name: autoProjectState.projectName,
                description: autoProjectState.projectDescription,
                emails: autoProjectState.emails,
                tags: autoProjectState.tags.filter((tag) => tag[BackendTagField.id]),
                labels: autoProjectState.labels,
                attributes: autoProjectState.attributes,
                active: true,
                status: project_status
            });
            if (Object.values(autoProjectState.filesDict).length > 0) {
                await request.post(storageService.loadFromStorage('token'), 'UPDATE_FILE_STATUS', postSignedData);
            }
        } catch (e) {
            const {data} = e.response;

            handleNameExistError(data);
            throw e;
        }
    };

    /**
     * deleteClass - when user wants to delete class
     * @param classObj - class object to delete
     * @param newState - newState
     **/
    const deleteClass = async (classObj, newState) => {
        try {
            setState({nameExistError: ''});
            if (BackendTagField.id in classObj) {
                const tagId = classObj[BackendTagField.id];

                newState.classes = newState.classes.filter((cl) => !cl[BackendTagField.id] || cl[BackendTagField.id] && cl[BackendTagField.id] !== tagId);
                newState.tags = newState.tags.filter((tag) => !tag[BackendTagField.id] || tag[BackendTagField.id] && tag[BackendTagField.id] !== tagId);
            } else {
                const tagId = classObj[BackendTagField.name];

                newState.classes = newState.classes.filter((cl) => cl[BackendTagField.name] && cl[BackendTagField.name] !== tagId);
                newState.tags = newState.tags.filter((tag) => tag[BackendTagField.name] && tag[BackendTagField.name] !== tagId);

                for (const key in newState.filesDict) {
                    if (newState.filesDict[key].tag[BackendTagField.name] === tagId) {
                        delete newState.filesDict[key].tag;
                        newState.filesDict[key].status = 'cancel';
                    }
                }
            }


            closeModal(setState, newState);
        } catch (e) {
            console.log(e);
        }
    };


    /**
     * deleteClassFromInventory - when user wants to delete class
     * @param tagId - tagId
     **/
    const deleteClassFromInventory = async (tagId:number) => {
        try {
            await request.post(storageService.loadFromStorage('token'), 'DELETE_TAG', {
                tag_ids: [tagId],
                data_project_id: autoProjectState.projectId,
            });
            const copyClasses = JSON.parse(JSON.stringify(autoProjectState.classes));
            const classes = copyClasses.filter((cl) => cl[BackendTagField.id] !== tagId);
            const copyTags = JSON.parse(JSON.stringify(autoProjectState.tags));
            const tags = copyTags.filter((tag) => tag[BackendTagField.id] !== tagId);

            setState({classes, tags});
        } catch (e) {
            console.log(e);
        }
    };

    /**
     * runAutoClassifier - start the auto classifier
     * */
    const runAutoClassifier = async (projectId, chosenTags) => {
        try {
            await request.post(storageService.loadFromStorage('token'), 'RUN_AUTO_CLASSIFIER', {
                data_project_id: projectId,
                tag_ids: chosenTags
            });
        } catch (e) {
            console.log(e);
        }
    };

    const navigateToDataProjects = () => {
        history.push({pathname: `/${_SYSTEM_TITLES.projects}`, state: {}});
    };

    const navigateToAutoStatusPage = (projectIdInit) => {
        history.push({
            pathname: '/auto_classification_project_status',
            state: {projectIdInit},
        });
    };

    const handleNameExistError = (error_data) => {
        if (error_data.type === BACKEND_ERRORS.dataProjectExist) {
            setState({nameExistError: _SYSTEM_TITLES.autoProjectNameExistError});
        } else if (error_data.type === BACKEND_ERRORS.featureNameExist) {
            setState({nameExistError: _SYSTEM_TITLES.autoProjectFeatureNameExistError});
        }
    };

    /**
     * setClassesForRandomPage - when page is init it set the classes as the object need to be like IClass
     */
    const setClassesForRandomPage = () => {
        const copyClasses = JSON.parse(JSON.stringify(autoProjectState.classes));
        const randomClasses:IClass[] = [];

        copyClasses.forEach((cl) => {
            const image_obj = cl.imageList.length > 0 ? cl.imageList[0] : {url: 'error'};
            const classObj = {
                isChosen: false,
                isShowAddToClassSuccess: false,
                isShowAddToClassError: false,
                tagId: cl.tag_id,
                name: cl.tag_name,
                isReadyForFineTune: 'isReadyForFineTune' in cl ? cl.isReadyForFineTune : false,
                img: {
                    fileServerId: image_obj.serverId,
                    url: image_obj.url,
                    title: image_obj.name
                }
            };

            randomClasses.push(classObj);
        });

        return randomClasses;
    };

    /**
     * addImagesToClass - set all images to class in the needed structure
     */
    const addImagesToClass = (currentClassIndex, copyManualImages) => {
        const copyClasses = JSON.parse(JSON.stringify(autoProjectState.classes));
        const imageListInClass = copyClasses[currentClassIndex].imageList;
        const newFiles = [];
        let imageClientId = copyClasses[currentClassIndex].imageList.length;

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        copyManualImages.forEach((img, i) => {
            if (img.approved) {
                // // @ts-ignore
                const newFile:any = {
                    name: img.title,
                    title: img.title,
                    status: 'done',
                    type: img.title.split('.').pop(),
                    errorMsg: '',
                    fileData: {
                        name: img.title,
                        file_id: img.fileServerId,
                        size: 0,
                        s3_name: img.title,
                        url: img.url
                    },
                    size: 0,
                    client_id: imageClientId++,
                    url: img.url,
                    serverId: img.fileServerId
                };

                // @ts-ignore
                newFiles.push(newFile);
            }
        });
        copyClasses[currentClassIndex].imageList = [...imageListInClass, ...newFiles];
        copyClasses[currentClassIndex]['isReadyForFineTune'] = true;
        setState({classes: copyClasses});
    };

    useEffect(() => {
        autoProjectState.files.length > 0 && setFiles(autoProjectState.files);
    }, [autoProjectState.files.length]);

    useEffect(() => {
        if (autoProjectState.uploadClassError) {
            (uploadCounter === numberOfFiles || uiFiledFileList.length > 0) && setState({uploadClassError: ''});
        }
    }, [autoProjectState.uploadClassError, uploadCounter, numberOfFiles, uiFiledFileList.length]);


    useEffect(() => {
        autoProjectState.classFiles.length > 0 && setUiFileListFromOutSide(autoProjectState.classFiles);
    }, [autoProjectState.classFiles]);

    useEffect(() => {

        if (popup && !autoProjectState.openCreateProjectModal) {
            const popProjectSplit = popup ? popup.split('-') : [];

            if (popProjectSplit.length > 0) {
                const popupName = popProjectSplit.slice(0, -1).join('-');

                if (popupName === 'modal-auto-create') {
                    setState({openCreateProjectModal: true});
                }
            }
        }

    }, [popup]);


    useEffect(() => {
        projectCopy ? getProjectData(projectCopy.id) : setState({minReference: _INPUT_RULES.MIN_REFERENCE_IMAGES});
    }, []);


    return {
        autoProjectState,
        setState,
        initialNewAutoProject,
        navigateToDataProjects,
        onDoneProcess,
        uiFileList,
        numberOfFiles,
        uploadCounter,
        editDraftAutoProject,
        uploadImages,
        onDeleteFile,
        deleteClass,
        deleteClassFromInventory,
        uiFiledFileList,
        retryAllFiledFiles,
        runAutoClassifier,
        navigateToAutoStatusPage,
        openExitModal,
        setOpenExitModal,
        fileBoilerPlate,
        setUiFileList,
        closeModal,
        setClassesForRandomPage,
        addImagesToClass
    };
};

export default useCreateAutoClassificationProject;

